App.controller('HealthPzuwSummaryCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', '$timeout', 'dataUser', 'Blob', 'FileSaver', '$rootScope', 'healthInsuranceService', 'moment', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, $timeout, dataUser, Blob, FileSaver, $rootScope, healthInsuranceService, moment, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Podsumowanie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.health.start';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.declaration;
    if (!$scope.data) {
        $state.go('root.health.start');
    } else {
        $scope.variantName = $scope.data.healthInsurance.name + ($scope.data.rehabilitation ? ' + Rehabilitacja ambulatoryjna' : '');
        if ($scope.data.senior1 || $scope.data.senior2 || $scope.data.senior3 || $scope.data.senior4) {
            $scope.variantName += ' + Komfort Senior';
        }
    }
    $scope.summaryPrice = $scope.stateParams.summaryPrice;
    $scope.employerPrice = $scope.data.healthInsurance.employerPrice;
    $scope.employeePrice = $scope.summaryPrice - $scope.employerPrice;
    $scope.proposedDate = $scope.data.proposedDate;

    let previousDeclarationStatus= $scope.stateParams.previousDeclarationStatus;
    if (previousDeclarationStatus) {
        if (previousDeclarationStatus === 'ENTERED') {
            popUpService.showPopUpBigInfo('', 'Uwaga', 'Nowo wypełniona deklaracja zastąpiła poprzednią wersję dokumentu. Do kadr należy dostarczyć aktualną deklarację.');
        } else if (previousDeclarationStatus === 'READY' || previousDeclarationStatus === 'ACTIVE') {
            popUpService.showPopUpBigInfo('', 'Uwaga', 'Nowo wypełniona deklaracja zastąpi poprzednią wersję dokumentu, pod warunkiem dostarczenia do kadr.');
        }
    }

    $scope.deliveryDate = $rootScope.CONFIGURATOR.healthInsurancePzuw.deliverDeclarationDayLimit;
    let today = new Date();
    if ($rootScope.CONFIGURATOR.healthInsurancePzuw.deliverDeclarationDayLimitException) {
        let exceptionDate = moment($rootScope.CONFIGURATOR.healthInsurancePzuw.deliverDeclarationDayLimitException);
        if (today.getFullYear() === exceptionDate.year() && today.getMonth() === exceptionDate.month() <= exceptionDate.date()) {
            $scope.deliveryDate = exceptionDate.date();
        }
    }

    $scope.getDeclaration = function(ev, value) {
        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        let id = value.uuid, barcode = value.barcode || '';
        healthInsuranceService.getDeclaration(id).then(function (success) {
            if (success.status === 200) {
                let data = new Blob([success.data], {type: 'application/pdf'});
                FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    }
}]);
